'use strict';

const Promise = require('promise');

const gwpWelcomeMessage = {
    def: {
        $welcomeBannerElement: null,
        $welcomeBannerContentElements: null,
        $welcomeInnerBannerElement: null,
        $approachingDiscountElements: null,
        $welcomeOverlayElement: null,
        delay: 4000
    },
    init: function(options) {
        gwpWelcomeMessage.def.$welcomeBannerElement = options.$parentElement.find('.js-gwp-welcome-banner');
        gwpWelcomeMessage.def.$welcomeBannerContentElements = options.$parentElement.find('.gwp-welcome-banner-title, .gwp-welcome-banner-content');
        gwpWelcomeMessage.def.$welcomeInnerBannerElement = options.$parentElement.find('.js-gwp-welcome-banner-inner');
        gwpWelcomeMessage.def.$approachingDiscountElements = options.$parentElement.find('.js-approaching-discount, .js-gwp-cart-banner');
        gwpWelcomeMessage.def.$welcomeOverlayElement = options.$parentElement.find('.js-gwp-welcome-overlay');
    },
    exists: function() {
        return gwpWelcomeMessage.def.$welcomeBannerElement.length > 0 && !gwpWelcomeMessage.def.$welcomeBannerElement.hasClass('hide');
    },
    promises: {
        hideWelcomeMessagePromise: function hideWelcomeMessage() {
            return new Promise(function(resolve) {
                gwpWelcomeMessage.def.$welcomeBannerElement.css('height', gwpWelcomeMessage.def.$welcomeInnerBannerElement.outerHeight());
                gwpWelcomeMessage.def.$welcomeInnerBannerElement.animate({
                    marginTop: '100%'
                }, 1300, function() {
                    gwpWelcomeMessage.def.$welcomeBannerElement.addClass('hide').removeAttr('style');
                    resolve();
                });
            });
        },
        fadeOutTextPromise: function fadeOutText() {
            return new Promise(function(resolve) {
                gwpWelcomeMessage.def.$welcomeBannerContentElements.animate({
                    opacity: '0'
                }, 600, function() {
                    resolve();
                });
            });
        },
        fadeInGwpPromise: function fadeInGwp() {
            return new Promise(function(resolve) {
                gwpWelcomeMessage.def.$approachingDiscountElements.fadeIn(300, function() {
                    resolve();
                });
            });
        },
        slideGwpPromise: function slideGwp() {
            return new Promise(function(resolve) {
                const $bonusProduct = $('.slide-gift');

                $bonusProduct.animate({left: 0}, 2000, function() {
                    resolve();
                });
            });
        }
    },

    animate: function() {
        if (!gwpWelcomeMessage.exists()) {
            return;
        }

        setTimeout(function() {
            Promise.all([
                gwpWelcomeMessage.promises.hideWelcomeMessagePromise(),
                gwpWelcomeMessage.promises.fadeOutTextPromise()
            ])
            .then(function() {
                return gwpWelcomeMessage.promises.fadeInGwpPromise();
            })
            .then(function() {
                gwpWelcomeMessage.def.$welcomeOverlayElement.fadeOut(300);
            })
            .then(function() {
                return gwpWelcomeMessage.promises.slideGwpPromise();
            });
        }, gwpWelcomeMessage.def.delay);
    }
};

module.exports = gwpWelcomeMessage;
